import { clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";
// src/utils/classNames.ts
const twMerge = extendTailwindMerge({
	prefix: "tw",
	extend: {
		theme: { radius: [
			"card",
			"popover",
			"modal",
			"sheet",
			"toast"
		] },
		classGroups: { opacity: [{ opacity: ["disabled"] }] }
	}
});
const cn = (...classes) => twMerge(clsx(...classes));
export { cn };

//# sourceMappingURL=classNames-DkX30VJU.js.map